import { cn } from './utils';

/**
 * FieldError — small text rendered below a form input.
 *
 * Returns null when no message — call sites can render unconditionally:
 *   <FieldError message={errors.legalName?.message} />
 */
export function FieldError({
  message,
  className,
}: {
  message?: string;
  className?: string;
}): JSX.Element | null {
  if (!message) return null;
  return (
    <p className={cn('mt-1 text-xs text-state-danger', className)} role="alert">
      {message}
    </p>
  );
}
